export const UserRoles = Object.freeze({
  ADMIN: 'admin',
  EMPLOYEE: 'employee',
  USER: 'user',
  EXTERNAL_COLLABORATOR: 'external-collaborator',
});

export default {
  UserRoles,
};
